export default {
  CapitalizeGrowth: 1,
  CapitalizeSustaining: 2,
  Expense: 3,
  Operating: 4
};